import React from 'react';
import ProcurementOrderLines from './ProcurementOrderLines';
import ProcurementProductName from './ProcurementProductName';
import ProcurementOrdersToggle from './ProcurementOrdersToggle';

export default function ProcurementDesktopView({ products, expandedProducts, onToggleExpand }) {
  return (
    <div className='table-responsive'>
      <table className='table table-striped table-hover procurement-table'>
        <thead className='thead-light'>
          <tr>
            <th>Товар</th>
            <th className='text-right'>Не забезпечено</th>
            <th className='text-right'>Вільно на складі</th>
            <th className='text-right'>Вже замовлено</th>
            <th className='text-right'>Ще замовити</th>
          </tr>
        </thead>
        <tbody>
          {products.map(product => {
            const expanded = expandedProducts.includes(product.productId);
            return (
              <React.Fragment key={product.productId}>
                <tr>
                  <td>
                    <ProcurementProductName product={product} />
                    <div className='mt-1'>
                      <ProcurementOrdersToggle
                        product={product}
                        expanded={expanded}
                        onToggleExpand={onToggleExpand}
                      />
                    </div>
                  </td>
                  <td className='text-right font-weight-bold'>{product.missingQuantity} шт</td>
                  <td className='text-right'>{product.freeStockQuantity} шт</td>
                  <td className='text-right'>{product.orderedQuantity} шт</td>
                  <td className='text-right font-weight-bold text-danger'>
                    {product.quantityToOrder} шт
                  </td>
                </tr>
                {expanded && (
                  <tr className='procurement-details-row'>
                    <td colSpan={5}>
                      <div id={`procurement-orders-${product.productId}`}>
                        <ProcurementOrderLines orders={product.orders} />
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
